function DataFilter(dataArrObj, filterValues) {
    var arrdata = dataArrObj;
    {
        Object.entries(filterValues).map(([key, value]) => {
            if (value?.length > 0 && key != 'dateFilter') {
                arrdata = arrdata.filter(function (item) {
                    
                    if (key === 'customerTypeName') {
                        const customerTypeName = item[key];
                        const customerTypeArray = customerTypeName?.split(", ").map(item => item?.trim());
                        return customerTypeArray?.includes(value)
                    }
                   else { return value?.includes(item[key]) }
                })
            }
            else if (value?.length > 0 && key == 'dateFilter') {
                arrdata = arrdata.filter((item) => {
                    const dateValue = item['createdDate'];
                    const dateValue2 = item['createdDate'];
                    return (dateValue >= value[0] && dateValue2 <= value[1])
                })

            }
        })
    }
    return arrdata
}


export default DataFilter;